import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../colorVars';
import { FormTextArea } from '../../../../../../../atomic/inputs/textArea/FormTextArea';
import { Body2 } from '../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../alertFormClass';
import style from './SymbolField.module.css';

export const SymbolField = observer(() => {
  const form = useAlertFormStore();
  return (
    <div className={`${style.container} noDragTag`}>
      <Body2 color={colors.lightGrey} fontWeight={700}>
        Symbols
      </Body2>
      <FormTextArea
        placeholder={`Enter one or more symbols separated by commas.
    e.g. AMD, AMC, AAPL `}
        color={colors.lightGrey}
        backgroundColor={colors.black}
        rows={4}
        controlledValue={form.symbol}
        onChange={(value) => form.setSymbol(value)}
      />
    </div>
  );
});
